import { render } from "./PentestSummary.vue?vue&type=template&id=4182cad4"
import script from "./PentestSummary.vue?vue&type=script&lang=js"
export * from "./PentestSummary.vue?vue&type=script&lang=js"

import "./PentestSummary.vue?vue&type=style&index=0&id=4182cad4&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__